<template>
  <div id="configuration_bandeau">
    <b-card class="create-form container" :header="'Modification'" header-tag="h3">
      <form-base type="bandeau_edit_admin"
                 :form-data=bandeauEditData
                 :default-submit-button="false"
                 :callbacks="{ bandeauEditAdmin: onConfirmBandeauEditAdmin }"
                 invoked-submit-button-name="bandeauEditAdmin"
                 @error="setErrorVisible"
                 :class="nameRoute"
      >
        <text-input label="bandeauConfiguration.bandeau_text" name="bandeau_text"
                    :custom-input="true" :required="true"
                    id="bandeau_text" v-model="bandeauEditData.bandeau_text"
        />

        <div id="bandeau_expiry" class="custom-input text">
          <div class="input-inner">
            <div class="label">{{ $t('bandeauConfiguration.bandeau_expiry') }}</div>
            <input class="form-control" type="date" v-model="bandeauEditData.bandeau_expiry"/>
          </div>
        </div>

        <radio-input label="bandeauConfiguration.bandeau_enabled" name="bandeau_enabled"
                     :custom-input="true" :required="true" :options="enabledOptions"
                     id="bandeau_enabled" v-model="bandeauEditData.bandeau_enabled" @input="updateEnabled"
        />
        <b-row>
          <submit-button v-if="!submitted || !success" class="btn btn-submit"
                         text="_validate" name="bandeauEditAdmin" value="Enregistrer"
          />
        </b-row>
      </form-base>
    </b-card>
  </div>
</template>

<script>
import navbar from '@/components/backoffice/navbar.vue'
import axios from 'axios'
import bTabs from 'bootstrap-vue/es/components/tabs/tabs'
import bCard from 'bootstrap-vue/es/components/card/card'
import CommonApi from '@/api/commonApi'
import Row from '@/components/backoffice/show/tabs/row.vue'
import textComponent from '@/components/backoffice/type/text.vue'
import fontAwesome from '@/components/global/icon/fontAwesome.vue'
import bButton from 'bootstrap-vue/es/components/button/button'
import buttonGroup from '@/components/backoffice/button/group.vue'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import dateInput from '@/components/frontoffice/form/baseInput/date'
import textInput from '@/components/frontoffice/form/baseInput/text.vue'
import submitButton from '@/components/frontoffice/form/baseInput/submit.vue'
import radioInput from '@/components/frontoffice/form/baseInput/radio.vue'
import formBase from '@/components/frontoffice/form/base'
import FormSubmitter from '@/api/formSubmitter'

export default {
  components: {
    submitButton,
    textInput,
    buttonGroup,
    bButton,
    fontAwesome,
    Row,
    textComponent,
    bCard,
    bTabs,
    dateInput,
    radioInput,
    formBase
  },

  props: {
    bandeauEditData: {
      type: Object,
      default: () => {
        return {
          bandeau_enabled: '',
          bandeau_expiry: '',
          bandeau_text: ''
        }
      }
    },
    title: {
      type: String,
      default: '_edit'
    }
  },

  data () {
    return {
      context: this.$route.matched[0].name === 'admin',
      nameRoute: this.$route.matched[0].name,
      rows: [

      ],
      buttons: [
      ],
      positioningClues: { position: 'right', overall: {} },
      formModel: {},
      formSchema: {},
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: false
      },
      enabledOptions: [
        { value: true, label: '_yes', selected: false },
        { value: false, label: '_no', selected: false }
      ],
      submitted: false,
      success: false
    }
  },

  created () {
    this.errorTitle = this.$t('error.error')
    this.errorMsg = this.$t('error.error')
    let commonApi = new CommonApi()
    commonApi.getBandeauConfigurationsForm()
      .then(bandeauDatas => {
        this.formModel = bandeauDatas.data.data
        this.formSchema['fields'] = []
        for (const name of Object.keys(bandeauDatas.data.data)) {
          if (name === 'bandeau_enabled') {
            for (let bool of this.enabledOptions) {
              bool.selected = bool.value === Boolean(this.formModel[name])
            }
          }
          this.bandeauEditData[name] = this.formModel[name]
        }
      })
  },

  methods: {
    updateEnabled (selectedValue) {
      this.bandeauEditData.bandeau_enabled = selectedValue
    },

    setErrorVisible (errors) {
      this.submitted = true
      this.success = false
      this.errors = errors
    },

    onConfirmBandeauEditAdmin (data) {
      this.success = true
      this.submitted = true
      let submitter = new FormSubmitter('bandeau_edit_admin')
      submitter.submitRequest(data)
        .then(response => {
          this.$router.push({ name: 'admin_bandeau' })
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="scss">
html {
  position: relative;
  min-height: 100%;
}
.back-layout {
  padding-bottom: 80px;
  @import '../../../../assets/sass/backoffice/main';
}
form #bandeau_text.custom-input, form #bandeau_expiry.custom-input, form #bandeau_enabled.custom-input {
  border-bottom: none !important;
  margin: 0;
  height: 90px;
}
input.btn-submit{
  color: #fff !important;
  background-color: #337ab7;
  border-color: #2e6da4;
}
</style>

